import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  font-weight: 400;\n  ",
        "\n\n  border-bottom: none;\n\n  transition: color ",
        ";\n\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  height: 1px;\n  border-radius: 2px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Link } from "@miro-site/core";
import { transparentize } from "polished";
import React from "react";
import styled from "styled-components";
var ExternalLink = function(param) {
    var title = param.title, link = param.link, onLinkClick = param.onLinkClick;
    return /*#__PURE__*/ _jsxs(Box, {
        $styles: {
            width: [
                325,
                550,
                550,
                550
            ]
        },
        $mb: [
            52,
            80,
            80,
            80
        ],
        children: [
            /*#__PURE__*/ _jsx(TopStroke, {}),
            /*#__PURE__*/ _jsx(BlogLink, {
                $mt: [
                    24,
                    40,
                    40,
                    40
                ],
                href: link,
                onClick: function(e) {
                    if (onLinkClick) {
                        e.preventDefault();
                        onLinkClick(e);
                    }
                },
                children: title
            })
        ]
    });
};
var BlogLink = styled(Link).withConfig({
    componentId: "sc-f5e4887b-0"
})(_templateObject(), function(props) {
    return props.theme.normalizeStyles(props.theme.typography.paragraphs.p0);
}, function(props) {
    return props.theme.animation.transitionDuration;
}, function(props) {
    return props.theme.colors.primaryIndigo;
}, function(props) {
    return props.theme.colors.primaryBlue;
});
var TopStroke = styled.div.withConfig({
    componentId: "sc-f5e4887b-1"
})(_templateObject1(), function(props) {
    return transparentize(0.8, props.theme.colors.primaryIndigo);
});
export default ExternalLink;
